import { GameFeatureCameraRigProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/properties/GameFeatureCameraRigProperties";
/**
 * Portrait properties for the camera rigging in the base game.
 */
export class BaseGameCameraRigPortraitProperties extends GameFeatureCameraRigProperties {
    constructor() {
        super(...arguments);
        this.name = "base-game-camera-rig-portrait";
        this.scatterPickZoomStart = 1.05;
        this.scatterPickZoomEnd = 1.3;
        this.scatterPickShake = 4;
    }
}
export class ChanceGameBackgroundCameraRigPortraitProperties extends GameFeatureCameraRigProperties {
    constructor() {
        super(...arguments);
        this.name = "chance-game-background-camera-rig-portrait";
        this.scatterPickZoomStart = 0.9;
        this.scatterPickZoomEnd = 1;
        this.scatterPickShake = 12;
    }
}
export class ChanceGameForegroundCameraRigPortraitProperties extends GameFeatureCameraRigProperties {
    constructor() {
        super(...arguments);
        this.name = "chance-game-foreground-camera-rig-portrait";
        this.scatterPickZoomStart = 1.05;
        this.scatterPickZoomEnd = 1.45;
        this.scatterPickShake = 20;
    }
}
//# sourceMappingURL=FeatureCameraRigPortraitProperties.js.map